import { shortenHash } from '../utils/format';

const Alert = ({ message, transactionHash, variant, setShowAlert }) => {
  const tone =
    variant === 'success'
      ? 'toast--success'
      : variant === 'danger' || variant === 'error'
        ? 'toast--danger'
        : 'toast--info';

  return (
    <div
      className={`toast ${tone}`}
      role="status"
      aria-live="polite"
      style={{ position: 'fixed' }}
    >
      <button
        type="button"
        className="toast__close"
        aria-label="Dismiss notification"
        onClick={() => setShowAlert(false)}
      >
        ×
      </button>
      <p className="toast__title">{message}</p>
      {transactionHash && (
        <p className="toast__hash" title={transactionHash}>
          Tx {shortenHash(transactionHash)}
        </p>
      )}
    </div>
  );
};

export default Alert;
